import { useState } from "react";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import {
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  Settings,
  ChevronRight,
  ArrowBack,
} from "@mui/icons-material";
import { useHistory, useLocation } from "react-router-dom";
import { usePermissions } from "./usePermissions";
import { useTabs } from "./TabContext";

const MobileBottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    canReadMaster,
    canReadTransaction,
    canReadAccounts,
    canReadAdministration,
    canReadReports,
    hasPermission,
  } = usePermissions();
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [transactionSubMenu, setTransactionSubMenu] = useState(null); // 'purchase' or 'sales'
  const [productSubMenu, setProductSubMenu] = useState(false); // For Product submenu
  const [accountMasterSubMenu, setAccountMasterSubMenu] = useState(false); // For Account Master submenu
  const [masterSubMenu, setMasterSubMenu] = useState(false); // For Master (Client/Vendor) submenu

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setTransactionSubMenu(null);
    setProductSubMenu(false);
    setAccountMasterSubMenu(false);
    setMasterSubMenu(false);
  };

  const { openTab } = useTabs();

  const handleNavigation = (path) => {
    openTab(path);
    handleMenuClose();
  };

  const menuItems = {
    accountMaster: [
      { label: 'Account Head', route: '/AccountHeadIndex' },
      { label: 'Asset', route: '/AssetIndex' },
      { label: 'Capital', route: '/CapitalIndex' },
      { label: 'Others', route: '/OtherOptionIndex' },
      { label: 'Balance Sheet', route: '/BalanceSheetHeadIndex' },
    ],
    master: [
      { label: 'Account Master', isNested: true, subMenuKey: 'accountMaster' }, // Account Master will have submenu
      { label: 'Bank', route: '/BankIndex' },
      { label: 'Currency', route: '/CurrencyTypeIndex' },
      { label: 'Company', route: '/CompanyEdit' },
      { label: 'Master', isNested: true, subMenuKey: 'masterSub' }, // Master will have submenu
      { label: 'Product', isNested: true, subMenuKey: 'product' }, // Product will have submenu
      { label: 'Terms & Conditions', route: '/TermsAndConditionsIndex' },
      // { label: 'Staff', route: '/StaffDashboard' },
    ],

    masterSub: [
      { label: 'Customer', route: '/ClientIndex' },
      { label: 'Supplier', route: '/VendorIndex' },
    ],

    product: [
      { label: 'Category', route: '/ProductCategoryIndex' },
      { label: 'Brand', route: '/ProductBrandIndex' },
      { label: 'Item', route: '/ProductItemIndex' },
      // { label: 'Product Relations', route: '/ProductRelationIndex' },
    ],


    transaction: {
      purchase: [
        { label: 'Purchase Order', route: '/PurchaseOrderIndex' },
        { label: 'Purchase', route: '/PurchaseIndex' },
        { label: 'Purchase Return', route: '/PurchaseReturnAgainstIndex' },

      ],

      sales:
        [

          { label: 'Sales', route: '/SaleIndex' },
          { label: 'Sale Return', route: '/SaleReturnAgainstIndex' },
        ],

    },
    accounts: [
      { label: 'Payment & Receipt', route: '/PaymentAndReceiptIndex' },
      { label: 'Journal Entry', route: '/JournalEntryIndex' },
      { label: 'Petty Cash', route: '/PettyCashIndex' },
    ],
    reports: [
      { label: 'Trial Balance', route: '/TrialBalanceReport' },
      { label: 'Trial Balance Advanced', route: '/TrialBalanceAdvancedReport' },
      { label: 'Cash Book', route: '/CashBook' },
      { label: 'Ledger', route: '/Ledger' },
      // { label: 'Vendor Due List', route: '/VendorDueList' },
      // { label: 'Customer Due List', route: '/CustomerDueList' },
      { label: 'Vendor Ageing', route: '/VendorAging' },
      { label: 'Customer Ageing', route: '/CustomerAging' },
      { label: 'Outstanding', route: '/Outstanding' },
      { label: 'Income Expense Summary', route: '/IncomeExpenseSummary' },
      { label: 'Petty Cash Book', route: '/PettyCashReport' },
      { label: 'Purchase Party & ItemWise Report', route: '/PurchasePartyandItemWiseReport' },
      { label: 'Sale Party & ItemWise Report', route: '/SalePartyandItemWiseReport' },
      { label: 'Stock Report', route: '/StockReport' },
      { label: 'Detailed Invoice', route: '/DetailedInvoiceReport' },
    ],
    settings: [
      { label: 'Users', route: '/UserIndex', permission: 'Read Administration' },
      { label: 'Roles', route: '/RoleIndex', permission: 'Read Administration' },
      { label: 'User Permissions', route: '/UserPermissionIndex', permission: 'Read Administration' },
      { label: 'Reset Password', route: '/PasswordChange' },
    ],
  };

  return (
    <>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid rgba(255,255,255,0.08)',
        }}
        elevation={8}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            height: '60px',
            '& .MuiBottomNavigationAction-root': {
              color: 'rgba(255, 255, 255, 0.55)',
              minWidth: '50px',
              padding: '6px 0',
              transition: 'all 0.2s ease',
              '&.Mui-selected': {
                color: '#818cf8',
              },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '10px',
              fontWeight: 600,
              marginTop: '2px',
              transition: 'all 0.2s ease',
              '&.Mui-selected': {
                fontSize: '10px',
                fontWeight: 700,
              }
            },
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<Dashboard sx={{ fontSize: 22 }} />}
            onClick={() => openTab('/Home')}
          />
          {canReadMaster && (
            <BottomNavigationAction
              label="Master"
              icon={<Business sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'master')}
            />
          )}
          {canReadTransaction && (
            <BottomNavigationAction
              label="Transaction"
              icon={<ShoppingCart sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'transaction')}
            />
          )}
          {canReadAccounts && (
            <BottomNavigationAction
              label="Accounts"
              icon={<AccountBalance sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'accounts')}
            />
          )}
          {canReadReports && (
            <BottomNavigationAction
              label="Reports"
              icon={<BarChart sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'reports')}
            />
          )}
          <BottomNavigationAction
            label="More"
            icon={<Settings sx={{ fontSize: 22 }} />}
            onClick={(e) => handleMenuOpen(e, 'settings')}
          />
        </BottomNavigation>
      </Paper>

      {/* Master Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'master'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            color: 'white',
            borderRadius: '16px',
            minWidth: '200px',
            maxHeight: '65vh',
            mb: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
            p: 0.5
          }
        }}
      >
        {!productSubMenu && !accountMasterSubMenu && !masterSubMenu ? (
          // Main master menu
          menuItems.master.map((item, idx) => (
            item.isNested ? (
              <MenuItem
                key={idx}
                onClick={() => {
                  if (item.subMenuKey === 'product') setProductSubMenu(true);
                  else if (item.subMenuKey === 'accountMaster') setAccountMasterSubMenu(true);
                  else if (item.subMenuKey === 'masterSub') setMasterSubMenu(true);
                }}
                sx={{
                  fontSize: '14px',
                  py: 1.25,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.25,
                  display: 'flex',
                  justifyContent: 'space-between',
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                <span>{item.label}</span>
                <ChevronRight sx={{ fontSize: 18 }} />
              </MenuItem>
            ) : (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{
                  fontSize: '14px',
                  py: 1.25,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.25,
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                {item.label}
              </MenuItem>
            )
          ))
        ) : productSubMenu ? (
          // Product submenu
          <>
            <MenuItem
              onClick={() => setProductSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 700 }}>Product</span>
            </MenuItem>
            {menuItems.product.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{
                  fontSize: '14px',
                  py: 1.25,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.25,
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        ) : accountMasterSubMenu ? (
          // Account Master submenu
          <>
            <MenuItem
              onClick={() => setAccountMasterSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 700 }}>Account Master</span>
            </MenuItem>
            {menuItems.accountMaster.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{
                  fontSize: '14px',
                  py: 1.25,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.25,
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        ) : (
          // Master (Client/Vendor) submenu
          <>
            <MenuItem
              onClick={() => setMasterSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 700 }}>Master</span>
            </MenuItem>
            {menuItems.masterSub.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{
                  fontSize: '14px',
                  py: 1.25,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.25,
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Transaction Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'transaction'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            color: 'white',
            borderRadius: '16px',
            minWidth: '220px',
            maxHeight: '65vh',
            mb: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
            p: 0.5
          }
        }}
      >
        {!transactionSubMenu ? (
          // Main transaction menu
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu('purchase')}
              sx={{
                fontSize: '14px',
                py: 1.25,
                px: 2,
                borderRadius: '8px',
                mx: 0.75,
                my: 0.25,
                display: 'flex',
                justifyContent: 'space-between',
                transition: 'all 0.2s ease',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <span>Purchase</span>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => setTransactionSubMenu('sales')}
              sx={{
                fontSize: '14px',
                py: 1.25,
                px: 2,
                borderRadius: '8px',
                mx: 0.75,
                my: 0.25,
                display: 'flex',
                justifyContent: 'space-between',
                transition: 'all 0.2s ease',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <span>Sales</span>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => handleNavigation('/StockJournalIndex')}
              sx={{
                fontSize: '14px',
                py: 1.25,
                px: 2,
                borderRadius: '8px',
                mx: 0.75,
                my: 0.25,
                transition: 'all 0.2s ease',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              Stock Journal
            </MenuItem>
          </>
        ) : (
          // Sub-menu (Purchase or Sales)
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu(null)}
              sx={{
                fontSize: '14px',
                py: 1,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 700 }}>
                {transactionSubMenu === 'purchase' ? 'Purchase' : 'Sales'}
              </span>
            </MenuItem>
            {/* Menu items */}
            {menuItems.transaction[transactionSubMenu].map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{
                  fontSize: '13px',
                  py: 1.2,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.75,
                  my: 0.2,
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Accounts Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'accounts'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            color: 'white',
            borderRadius: '16px',
            minWidth: '200px',
            maxHeight: '65vh',
            mb: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
            p: 0.5
          }
        }}
      >
        {menuItems.accounts.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{
              fontSize: '14px',
              py: 1.25,
              px: 2,
              borderRadius: '8px',
              mx: 0.75,
              my: 0.25,
              transition: 'all 0.2s ease',
              '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Reports Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'reports'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            color: 'white',
            borderRadius: '16px',
            minWidth: '200px',
            maxHeight: '65vh',
            mb: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
            p: 0.5
          }
        }}
      >
        {menuItems.reports.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{
              fontSize: '14px',
              py: 1.25,
              px: 2,
              borderRadius: '8px',
              mx: 0.75,
              my: 0.25,
              transition: 'all 0.2s ease',
              '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Settings Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'settings'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "rgba(15, 23, 42, 0.98)",
            backdropFilter: "blur(16px)",
            color: 'white',
            borderRadius: '16px',
            minWidth: '200px',
            maxHeight: '65vh',
            mb: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.3)',
            p: 0.5
          }
        }}
      >
        {menuItems.settings
          .filter((item) => !item.permission || hasPermission(item.permission))
          .map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{
              fontSize: '14px',
              py: 1.25,
              px: 2,
              borderRadius: '8px',
              mx: 0.75,
              my: 0.25,
              transition: 'all 0.2s ease',
              '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileBottomNav;
